import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

import Card from 'components/DesignSystem/Card';
import RelatorioTable from 'components/Relatorios/shared/RelatorioTable';
import Selector from 'components/DesignSystem/Selector';

import useSemanalSecaoParams from 'hooks/Relatorios/Semanal/useSemanalSecaoParams';
import { useGetSemanalVisaoGeralQuery } from 'services/api/products/relatorios';
import Chart, { SERIE_COR } from './Chart';

import './index.scss';

const SUBSISTEMA_PADRAO = 'SE/CO';

export default function VisaoGeral() {
  const params = useSemanalSecaoParams();
  const [subsistema, setSubsistema] = useState(SUBSISTEMA_PADRAO);

  const { data, isLoading } = useGetSemanalVisaoGeralQuery({ ...params, subsistema });

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const columns = ['Série', ...data.periodos];
  const rows = data.series.map((s) => [s.nome, ...s.valores]);
  const rowDotColors = data.series.map((s) => SERIE_COR[s.nome]);

  return (
    <Card
      title="Visão Geral"
      className="relatorio-table"
      actions={(
        <Selector
          label="Subsistema"
          containerClassName="visao-geral__selector"
          value={subsistema}
          setValue={setSubsistema}
        >
          {data.subsistemas.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </Selector>
      )}
    >
      <Chart data={data} />
      <RelatorioTable
        titulo={data.titulo}
        columns={columns}
        rows={rows}
        rowDotColors={rowDotColors}
        semCard
      />
    </Card>
  );
}
